<script lang="ts">
export interface TreeAccordionItemAction {
  icon: string;
  actionName: string;
  enabled: boolean;
}

export interface TreeAccordionNode {
  name: string;
  label?: string;
  enabled: boolean;
  children?: TreeAccordionNode[];
  isRoot?: boolean;
  actions?: TreeAccordionItemAction[];
  icon?: string;
  totalCount?: number;
  foldable?: boolean;
  selectedPath?: string[];
  path?: string[];
}
</script>

<script setup lang="ts">
import { provide, ref } from "vue";
import TreeAccordionItem from "./TreeAccordionItem.vue";

const { nodes, selectable = false } = defineProps<{
  nodes: TreeAccordionNode[];
  selectable?: boolean;
}>();
const emit = defineEmits<{
  itemAction: [action: string, itemName: string];
  itemSelected: [itemPath: string[]];
}>();
const selectedPath = ref<string[]>([]);
defineExpose({
  selectedPath,
});

provide("emitItemSelected", (path: string[]) => {
  if (selectable) {
    selectedPath.value = path;
    emit("itemSelected", selectedPath.value);
  }
});

provide("emitItemAction", (action: string, itemName: string) => {
  emit("itemAction", action, itemName);
});
</script>

<template>
  <div class="accordion">
    <TreeAccordionItem
      v-for="(node, index) in nodes"
      :key="index"
      :name="node.name"
      :label="node.label"
      :children="node.children"
      :is-root="true"
      :actions="node.actions"
      :enabled="node.enabled"
      :icon="node.icon"
      :total-count="node.totalCount"
      :foldable="node.foldable"
      :selected-path="selectedPath"
      :path="[node.name]"
    />
  </div>
</template>

<style scoped>
.accordion {
  display: flex;
  flex-direction: column;
  background-color: var(--color-background-primary);
  gap: var(--spacing-8);
}
</style>
